import { ChecklistSectionCard } from './checklist/ChecklistSectionCard';
import { useSignOffIdentity } from './checklist/useSignOffIdentity';
import { CASE_CHECKLIST_SECTIONS } from './checklist/caseChecklist';
import { ConfirmTickCard } from './ConfirmTickCard';

// In two columns Anterior (most checks) spans both rows beside the shorter two; three columns share one row.
const SECTION_GRID_CLASS: Readonly<Record<string, string>> = {
    anterior: 'lg:row-span-2 2xl:row-span-1'
};

interface VcaChecklistStepProps {
    signedOff: boolean;
    onChange: (signedOff: boolean) => void;
}

function VcaChecklistStep({ signedOff, onChange }: VcaChecklistStepProps) {
    const { name, date } = useSignOffIdentity();

    return (
        <div className="w-full flex flex-col gap-4">
            <div>
                <h3 className="text-sm font-semibold text-gray-800 mb-1">Case checklist</h3>
                <p className="text-xs text-gray-500">
                    Review each check below, then confirm you checked it all to recommend retention.
                </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-4">
                {CASE_CHECKLIST_SECTIONS.map((section) => (
                    <ChecklistSectionCard
                        key={section.id}
                        section={section}
                        className={SECTION_GRID_CLASS[section.id] ?? ''}
                    />
                ))}
            </div>

            <ConfirmTickCard
                checked={signedOff}
                onChange={onChange}
                label="Yes, I checked it all"
                detail={`Signed off by ${name} · ${date}`}
            />
        </div>
    );
}

export { VcaChecklistStep };
